export default "__VITE_ASSET__Dc2GxnC6__"